module.exports = __webpack_public_path__ + "media/images/pic/meat-7638900db0f38d904915ccb28fc69f29.webp";